import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "22",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#0A1121",
      d: "M18 0H2C.9 0 0 .9 0 2v11c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2m1 13c0 .55-.45 1-1 1l-1 1H2l1-1H2c-.55 0-1-.45-1-1V5h18zM1 4V2c0-.55.45-1 1-1h16c.55 0 1 .45 1 1v2z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#0A1121",
      d: "M11.5 3h-8c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h8c.28 0 .5.22.5.5s-.22.5-.5.5"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#0A1121",
      "fill-rule": "evenodd",
      d: "M16.83 7.17a4.01 4.01 0 0 0-5.66 0l-2.1 2.11c-.05.04-.1.09-.14.14-.05.08-.08.18-.08.28a.503.503 0 0 0 .5.5c.13 0 .26-.06.35-.14l2.18-2.18a3 3 0 0 1 4.24 0 3 3 0 0 1 0 4.24l-2.83 2.83c-.15.15-.31.28-.47.39-.33.21-.68.35-1.05.43-.34.07-.7.08-1.05.03-.61-.1-1.2-.38-1.67-.85-.33-.33-.57-.72-.71-1.14a.505.505 0 0 0-.83-.14.51.51 0 0 0-.12.44l.03.11c.19.53.5 1.02.92 1.44.51.51 1.13.86 1.79 1.03.4.11.81.15 1.21.13.42-.01.84-.09 1.24-.24.43-.16.83-.4 1.19-.71.08-.06 3.06-3.04 3.06-3.04a4.01 4.01 0 0 0 0-5.66",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#0A1121",
      "fill-rule": "evenodd",
      d: "M10.75 17.81c-.03-.01-.07-.01-.1-.01-.14 0-.27.06-.35.15-.03.02-.05.05-.07.07l-2.11 2.1a3 3 0 0 1-4.24 0 3 3 0 0 1 0-4.24l2.83-2.83c.15-.15.31-.28.47-.39.33-.21.68-.35 1.05-.43.34-.07.7-.08 1.05-.03.61.1 1.2.38 1.67.85.33.33.56.72.71 1.13.08.18.26.31.46.31.1 0 .2-.03.28-.09a.6.6 0 0 0 .09-.07c.08-.09.13-.21.13-.34 0-.03 0-.07-.01-.1l-.03-.11c-.19-.53-.5-1.02-.92-1.44-.51-.51-1.13-.86-1.79-1.03-.4-.11-.81-.15-1.21-.13-.42.01-.84.09-1.24.24-.43.16-.83.4-1.19.71-.08.06-3.06 3.04-3.06 3.04a4.01 4.01 0 0 0 0 5.66 4.01 4.01 0 0 0 5.66 0L11 18.66c.09-.1.15-.22.15-.36 0-.24-.18-.44-.4-.49",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }